module.exports = __webpack_public_path__ + "img/GODIVA_background.95721e30.png";